<ng-template #speakerDetailContainer></ng-template>
